'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Logger = require('logplease');

var logger = Logger.create('cache', {
  color: Logger.Colors.Magenta
});
Logger.setLogLevel('ERROR');

var Cache = /*#__PURE__*/function () {
  function Cache(store) {
    _classCallCheck(this, Cache);

    this._store = store;
  }

  _createClass(Cache, [{
    key: "status",
    get: function get() {
      return this._store.db.status;
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._store) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error('No cache store found to close')));

              case 2:
                if (!(this.status === 'open')) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this._store.close();

              case 5:
                return _context.abrupt("return", Promise.resolve());

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._store) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new Error('No cache store found to open')));

              case 2:
                if (!(this.status !== 'open')) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return this._store.open();

              case 5:
                return _context2.abrupt("return", Promise.resolve());

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  _this._store.get(key, function (err, value) {
                    if (err) {
                      // Ignore error if key was not found
                      if (err.toString().indexOf('NotFoundError: Key not found in database') === -1 && err.toString().indexOf('NotFound') === -1) {
                        return reject(err);
                      }
                    }

                    resolve(value ? JSON.parse(value) : null);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }() // Set value in the cache and return the new value

  }, {
    key: "set",
    value: function set(key, value) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2._store.put(key, JSON.stringify(value), function (err) {
          if (err) {
            // Ignore error if key was not found
            if (err.toString().indexOf('NotFoundError: Key not found in database') === -1 && err.toString().indexOf('NotFound') === -1) {
              return reject(err);
            }
          }

          logger.debug("cache: Set ".concat(key, " to ").concat(value));
          resolve();
        });
      });
    }
  }, {
    key: "load",
    value: function load() {} // noop

  }, {
    key: "destroy",
    value: function destroy() {} // noop
    // Remove a value and key from the cache

  }, {
    key: "del",
    value: function () {
      var _del = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  _this3._store.del(key, function (err) {
                    if (err) {
                      // Ignore error if key was not found
                      if (err.toString().indexOf('NotFoundError: Key not found in database') === -1 && err.toString().indexOf('NotFound') === -1) {
                        return reject(err);
                      }
                    }

                    resolve();
                  });
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function del(_x2) {
        return _del.apply(this, arguments);
      }

      return del;
    }()
  }]);

  return Cache;
}();

module.exports = Cache;